import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Buffer } from 'buffer';

//* import images
import dotIcon from '../../assets/images/icons/Dot.svg';
import Calender from '../../assets/images/icons/CalenderIcon.svg';

//* import services
import {
  getExamScheduleById,
  getExamByExamShortName,
  saveStudentInExam,
  updateStudentInExam,
  getStudentFromExam,
} from '../../services/examsService';
import ProgressBar from '../../SubComponent/ProgressBar';
import {
  isEmailValid,
  isPhoneNumberValid,
  isCheckBoxFieldValid,
  isRequiredFieldValid,
} from '../../services/Validations';
import { presentLoader, dismissLoader } from '../../services/loaderService';
import { uploadFilesAWS } from '../../services/AwsBucket';
import { successToast, errorToast } from '../../services/Toast';

//* import subComponent
import Button from '../../SubComponent/Button';
import { CustomTextInput } from '../../SubComponent/CustomTextInput';
import Dropdown from '../../SubComponent/Dropdown';
import CustomRadio from '../../SubComponent/CustomRadio';
import CustomCheckBox from '../../SubComponent/CustomCheckBox';
import CustomDate from '../../SubComponent/CustomDate';
import PaymentIcon from '../../assets/images/icons/PaymentIcon.svg';
import Grid from '@mui/material/Grid';

//* import mui
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { makeStyles } from '@mui/styles';

import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//* import css
import cssClasses from './ExamDetails.module.css';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Accordion } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  CardContainer: {
    width: 'min(112rem , 50%)',
    margin: 'auto',
  },
  Details: {
    padding: '0 !important',
  },
}));

function ExamDetails() {
  let params = useParams();
  let navigate = useNavigate();
  let examShortName = params.examShortName;
  const loggedInUser = useSelector((state) => state.Auth.user);

  const [expanded, setExpanded] = useState(false);

  const [SubExamData, setSubExamData] = useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const classList = useStyles();

  const [progressBarStatus, setProgressBarStatus] = useState(null);

  const [examObject, setExamObject] = useState(null);
  const [formFields, setFormFields] = useState(null);
  const [formHelperText, setFormHelperText] = useState(null);
  const [studentInfoFromExam, setStudentInfoFromExam] = useState(null);
  const [paymentSlipOffline, setPaymentSlipOffline] = useState(null);
  const [payNowButton, setPayNowButton] = useState(true);
  const [payNowOfflineButton, setPayNowOfflineButton] = useState(true);
  const [fileName, setFileName] = useState('');

  useEffect(() => {
    getExamFromServer();
  }, [examShortName]);

  async function getExamFromServer() {
    presentLoader();
    getExamByExamShortName(examShortName)
      .then((res) => {
        if (res.empty) {
          errorToast('Invalid exam.');
          navigate('/home');
          dismissLoader();
        } else {
          let _examObj = res.docs.map((m) => ({ docID: m.id, ...m.data() }))[0];
          let _field = {};
          _examObj.formFields.forEach((element) => {
            if (element.fieldType === 'Checkboxes') {
              _field[element.fieldName] = [];
            } else {
              _field[element.fieldName] = '';
            }
          });
          setExamObject(_examObj);
          console.log('1111', _examObj);
          setFormFields({ ..._field });

          let _fieldForHelperText = Object.keys(_field).reduce(
            (a, v) => ({ ...a, [v]: '' }),
            {}
          );
          setFormHelperText({ ..._fieldForHelperText });

          if (loggedInUser?.docId && _examObj.docID) {
            getStudentInfoFromServer(_examObj.docID);
            getSubExamsFromServer(_examObj.docID);
          }
          dismissLoader();
        }
      })
      .catch((err) => {
        console.log(err);
        dismissLoader();
        navigate('/home');
      });
  }
  async function getStudentInfoFromServer(_docID) {
    getStudentFromExam(_docID, loggedInUser?.docId).then((res) => {
      if (res.exists) {
        setStudentInfoFromExam(res.data());
      }
    });
  }
  function getSubExamsFromServer(_examDocID) {
    getExamScheduleById(_examDocID).then((res) => {
      let _subExams = res.docs.map((m) => ({ docID: m.id, ...m.data() }));
      console.log('SubExams', _subExams);
      setSubExamData(_subExams);
    });
  }

  async function selectFile(_file, _fieldType, _fieldName) {
    if (
      _file &&
      _fieldType === 'Upload Image' &&
      _file.type.includes('image')
    ) {
      fileUploadTOGoogle(_file, _fieldType, _fieldName);
    }
    if (_file && _fieldType === 'Upload PDF' && _file.type.includes('pdf')) {
      fileUploadTOGoogle(_file, _fieldType, _fieldName);
    }
  }

  async function fileUploadTOGoogle(_file, _fieldType, _fieldName) {
    presentLoader();
    let fileName = `${examObject.docID}_${
      loggedInUser?.docId
    }_${_fieldName}.${_file.name.split('.').pop()}`;
    if (_fieldName === 'Photo') {
      fileName =
        loggedInUser?.docId +
        '/photos/' +
        `${examObject.docID}_${loggedInUser?.docId}.${_file.name
          .split('.')
          .pop()}`;
    }

    let fileObjectToUpload = {
      name: _file.name,
      size: _file.size,
      key: process.env.REACT_APP_bucketRootKey + '/' + fileName,
      arrayBuffer: _file,
    };

    if (_fieldName === 'Photo') {
      let bff = await toBase64(_file);
      fileObjectToUpload.arrayBuffer = new Buffer.from(
        bff.replace(/^data:image\/\w+;base64,/, ''),
        'base64'
      );
    }

    setFileName(fileObjectToUpload.name);

    uploadFilesAWS(
      [fileObjectToUpload],
      (data) => {
        if (data?.result.includes('Files Uploaded')) {
          let img_url =
            'https://exam-management.s3.ap-south-1.amazonaws.com/' +
            fileObjectToUpload.key;
          if (_fieldName === 'Photo') {
            img_url = fileObjectToUpload.key;
          }
          setFormFields((pre) => {
            pre[_fieldName] = img_url;
            return Object.assign({}, pre);
          });
          dismissLoader();
        } else {
          errorToast('Something went wrong! Try again');
        }
      },
      (err) => {
        console.log('err => ', err);
        errorToast('Something went wrong! Try again');
      },
      (progress) => {
        console.log('progress => ', progress);
      }
    );
  }

  function validation() {
    let flag = true;
    examObject?.formFields?.forEach((_element) => {
      if (_element.isRequired) {
        let _ValidationObj = null;
        if (_element.fieldType === 'Email') {
          _ValidationObj = isEmailValid(formFields[_element.fieldName]);
        } else if (_element.fieldType === 'Phone No.') {
          _ValidationObj = isPhoneNumberValid(
            formFields[_element.fieldName],
            _element.fieldName
          );
        } else if (_element.fieldType === 'Checkboxes') {
          _ValidationObj = isCheckBoxFieldValid(
            formFields[_element.fieldName],
            _element.fieldName
          );
        } else {
          _ValidationObj = isRequiredFieldValid(
            formFields[_element.fieldName],
            _element.fieldName
          );
        }
        if (!_ValidationObj.flag) {
          flag = false;
        }
        setFormHelperText((pre) => {
          pre[_element.fieldName] = _ValidationObj.helperText;
          return Object.assign({}, pre);
        });
      }
    });
    return flag;
  }
  function apply() {
    let formIsValid = validation();
    if (loggedInUser?.docId && formIsValid) {
      presentLoader();
      let _postBody = Object.assign({}, formFields);
      _postBody.paymentStatus = 'pending';
      _postBody.studentFullNameForSearch =
        formFields['Full Name'].toLowerCase();
      _postBody.studentID = loggedInUser?.docId;
      _postBody.phone = loggedInUser?.phone;
      _postBody.email = loggedInUser?.email;

      saveStudentInExam(examObject.docID, loggedInUser?.docId, _postBody)
        .then((res) => {
          successToast('Data saved Successfully!');
          setPayNowButton(false);
          if (
            examObject.paymentType === 'Offline' ||
            examObject.paymentType === 'Both'
          ) {
            setProgressBarStatus(1);
            dismissLoader();
          } else {
            dismissLoader();
          }
        })
        .catch((err) => {
          console.log(err);
          errorToast('Something went wrong! Try again');
          dismissLoader();
        });
    }
  }

  async function selectFilePaymentSlip(_file, paymentType) {
    if (paymentType === 'Offline' && _file && _file?.type.includes('image')) {
      setPayNowOfflineButton(false);
      setPaymentSlipOffline(_file);
    }
  }

  function savePayment() {
    if (
      examObject.paymentType === 'Offline' ||
      examObject.paymentType === 'Both'
    ) {
      let fileObjectToUpload = {
        name: paymentSlipOffline.name,
        size: paymentSlipOffline.size,
        key:
          process.env.REACT_APP_bucketRootKey +
          '/' +
          loggedInUser?.docId +
          '/docs' +
          `/${examObject.examShortName}_${
            loggedInUser?.docId
          }_offlinePaymentSlip.${paymentSlipOffline.name.split('.').pop()}`,
        arrayBuffer: paymentSlipOffline,
      };

      uploadFilesAWS(
        [fileObjectToUpload],
        (data) => {
          if (data?.result.includes('Files Uploaded')) {
            let postBody = {
              paymentMethod: 'Offline',
              paymentSlip:
                'https://exam-management.s3.ap-south-1.amazonaws.com/' +
                fileObjectToUpload.key,
              paymentStatus: 'done',
            };
            updateStudentInExam(examObject.docID, loggedInUser?.docId, postBody)
              .then((result) => {
                //*  Success Toast
                successToast('Payment Successful.');
                navigate('/home');
              })
              .catch((err) => {
                console.log(err);
                errorToast('Something went wrong! Try again');
                //!  Error Toast
              });
          } else {
            console.log(data);
            errorToast('Something went wrong! Try again');
          }
        },
        (err) => {
          console.log(err);
          errorToast('Something went wrong! Try again');
          //!  Error Toast
        },
        (progress) => {
          console.log('progress => ', progress);
        }
      );
    }
  }

  async function processToOnlinePayment() {
    var options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: +examObject.fee * 100,
      currency: 'INR',
      name: examObject.name,
      description: '',
      image: examObject.image,
      handler: razorpayResponse,
      prefill: {
        name: loggedInUser ? loggedInUser['Full Name'] : '',
        email: loggedInUser?.email,
        contact: loggedInUser?.phone,
      },
    };

    console.log('options', options);
    var rzp1 = new window.Razorpay(options);
    rzp1.on('payment.failed', paymentFailed);
    rzp1.open();
  }

  const paymentFailed = (response) => {
    errorToast(response.error.description);
  };

  const razorpayResponse = (paymentResponse) => {
    presentLoader();
    let postBody = {
      razorpay_payment_id: paymentResponse.razorpay_payment_id,
      paymentMethod: 'Online',
      paymentStatus: 'done',
    };
    updateStudentInExam(examObject.docID, loggedInUser?.docId, postBody)
      .then((result) => {
        successToast('Payment Successful.');
        dismissLoader();
        navigate('/home');
      })
      .catch((err) => {
        console.log(err);
        errorToast('Something went wrong! Try again');
        dismissLoader();
        //!  Error Toast
      });
  };

  const breadcrumbs = [
    <Link underline='hover' key='1' color='inherit' href='/home/'>
      <HomeOutlinedIcon style={{ width: '2.4rem', height: '2.4rem' }} />
    </Link>,
    <Link underline='hover' key='2' color='inherit'>
      {examObject ? (
        <p className={cssClasses.Title}>{examObject.name}</p>
      ) : null}
    </Link>,
  ];

  return (
    <Box height={'100%'} display={'flex'} flexDirection={'column'}>
      <div className={cssClasses.breadcrumbDiv}>
        <Breadcrumbs separator='›' fontSize='small' aria-label='breadcrumb'>
          {breadcrumbs}
        </Breadcrumbs>
      </div>

      {examObject &&
        formFields &&
        formHelperText &&
        progressBarStatus === null && (
          <>
            <Grid
              container
              columns={16}
              style={{
                marginTop: 10,
                flex: 1,
                backgroundColor: '#FFFFFF',
                width: 'fit-content',
                margin: '2rem auto',
                borderRadius: '8px',
              }}
              className={classList.detailsCard}
            >
              <Grid
                item
                xs={16}
                sm={16}
                md={16}
                lg={16}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <div className={cssClasses.ExamDetailsDiv}>
                  <div className={cssClasses.paddingAround}></div>
                  <Grid
                    container
                    columns={16}
                    width='none'
                    className={cssClasses.ImageDiv}
                  >
                    <Grid item xs={16} sm={16} md={16} lg={12}>
                      <div className={cssClasses.StatusDiv}>
                        {new Date(examObject.applicationCloseDate) >
                        new Date() ? (
                          <div className={cssClasses.statusWrapperGreen}>
                            <div className={cssClasses.dot}>
                              <img src={dotIcon} alt='dot' />
                            </div>
                            <div className={cssClasses.statusTextGreen}>
                              <p>Registration Open</p>
                            </div>
                          </div>
                        ) : (
                          <div className={cssClasses.statusWrapperRed}>
                            <div className={cssClasses.dot}>
                              <FiberManualRecordIcon
                                style={{
                                  width: '1rem',
                                  height: '1rem',
                                  color: 'red',
                                }}
                              />
                            </div>
                            <div className={cssClasses.statusTextRed}>
                              <p>Registration Closed</p>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className={cssClasses.paddingAround}></div>
                      <p className={cssClasses.HeaderTitle}>
                        Exam name : {examObject.name}
                      </p>

                      <div className={cssClasses.paddingAround}></div>

                      <div className={cssClasses.RadioDiv}>
                        <div className={cssClasses.RadioDiv}>
                          <div className={cssClasses.CalenderImg}>
                            <img src={Calender} alt={''} />
                          </div>
                          <div className={cssClasses.TextTag}>
                            <p className={cssClasses.subTitle}> Held on </p>
                            <p className={cssClasses.sub2Title}>
                              {examObject.examDate}
                            </p>
                          </div>
                        </div>

                        <div className={cssClasses.ContentWrap}>
                          <div className={cssClasses.CalenderImg}>
                            <img src={PaymentIcon} alt={''} />
                          </div>
                          <div className={cssClasses.TextTag}>
                            <p className={cssClasses.subTitle}>
                              Payment Method
                            </p>
                            <p className={cssClasses.sub2Title}>
                              {' '}
                              {examObject.paymentType === 'Both'
                                ? 'Online or Offline'
                                : examObject.paymentType}
                            </p>
                          </div>
                        </div>
                      </div>

                      <Grid container spacing={2} style={{ marginTop: '3rem' }}>
                        <Grid className={cssClasses.RadioDiv}>
                          <p className={cssClasses.sub2Title}>
                            Registration Start Date:
                          </p>
                          <p
                            className={cssClasses.sub2Title}
                            style={{ marginLeft: '1rem' }}
                          >
                            {examObject.applicationOpenDate}
                          </p>
                        </Grid>

                        <Grid className={cssClasses.ContentWrap}>
                          <p className={cssClasses.sub2Title}>
                            Registration End Date:
                          </p>
                          <p
                            className={cssClasses.sub2Title}
                            style={{ marginLeft: '1rem' }}
                          >
                            {examObject.applicationCloseDate}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={16}
                      sm={16}
                      md={16}
                      lg={2}
                      className={cssClasses.RightDiv}
                    >
                      <img
                        src={examObject.image}
                        alt={''}
                        style={{ width: 100, height: 100 }}
                      />
                    </Grid>
                  </Grid>
                  <div className={cssClasses.ContentWrap}>
                    <div style={{ margin: '3rem 3rem 3rem 0' }}>
                      <Button
                        btnName='Apply Now'
                        clicked={() => {
                          setProgressBarStatus(0);
                        }}
                        style={{ color: '#ffffff', backgroundColor: '#6941C6' }}
                        disable={
                          studentInfoFromExam?.paymentStatus === 'done' ||
                          new Date(examObject.applicationCloseDate) < new Date()
                        }
                      />
                    </div>
                    <p
                      className={cssClasses.feeText}
                      style={{ margin: '3rem 3rem 3rem 0' }}
                    >
                      Exam Fee :
                      <span className={cssClasses.fee}>₹{examObject.fee}</span>{' '}
                    </p>
                  </div>
                  <Divider style={{ width: 'auto' }} />

                  <div style={{ margin: ' 0 4rem', width: '500px' }}>
                    <p className={cssClasses.feeText}>Description:</p>
                    <p
                      className={cssClasses.paraGraph}
                      dangerouslySetInnerHTML={{
                        __html: examObject.description,
                      }}
                    ></p>
                  </div>
                </div>
              </Grid>
            </Grid>

            <Grid
              container
              columns={16}
              style={{
                marginTop: 10,
                flex: 1,
                width: 'fit-content',
                margin: ' auto',
              }}
              className={classList.detailsCard}
            >
              <Grid item xs={16} sm={16} md={16} lg={16}>
                <Box className={cssClasses.subContainerTitle}>Exams</Box>
                <Box className={cssClasses.BoxDiv}>
                  <Box className={cssClasses.subTitleDiv}>Exam Name</Box>
                  <Box className={cssClasses.subTitleDiv}>Exam Date</Box>
                  <Box className={cssClasses.subTitleDiv}>Exam Time</Box>
                </Box>

                {SubExamData.map((object, index) => (
                  <Accordion expanded={expanded === index} onChange={handleChange(index)} >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1bh-content' id='panel1bh-header'>
                      <Box sx={{ width: '100%', flexShrink: 0 }}  >
                      <Box className={cssClasses.BoxDiv2}>
                        <Box className={cssClasses.box2}>{object.examName}</Box>
                        <Box className={cssClasses.box6}>{object.examDates[0].date}</Box>
                        <Box className={cssClasses.box6}>{object.examDates[0].slots[0].time.split(' ')[4]}</Box>
                      </Box>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails className={classList.Details}>
                      {object.subjects.map((subjectObject, index) => (
                        <Box
                          className={cssClasses.BoxDiv1}
                          key={`${subjectObject}_${index}`}
                        >
                          <Box className={cssClasses.subtextTitle}>
                            {subjectObject.subjectName}
                          </Box>
                          <Box className={cssClasses.subtextTitle}>
                            {subjectObject.subjectExamDate}
                          </Box>
                          <Box className={cssClasses.subtextTitle}>
                            {subjectObject.subjectExamTime.split(' ')[4]}
                          </Box>
                        </Box>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>
            </Grid>
          </>
        )}

      <Box flex={1} className={classList.CardContainer}>
        {examObject &&
          formFields &&
          formHelperText &&
          progressBarStatus !== null && (
            <div style={{ backgroundColor: '#FFFFFF' }}>
              {(examObject.paymentType === 'Offline' ||
                examObject.paymentType === 'Both') && (
                <ProgressBar activeStep={progressBarStatus} />
              )}

              {examObject &&
                formFields &&
                formHelperText &&
                progressBarStatus === 0 && (
                  <div
                    style={{
                      marginTop: 20,
                      flex: 1,
                      margin: ' 2rem',
                      backgroundColor: '#FFFFFF',
                      paddingTop: '4rem',
                      paddingBottom: '4rem',
                    }}
                  >
                    <Divider />
                    <Grid
                      container
                      columns={{ lg: 12, sm: 12, md: 12, xs: 12 }}
                    >
                      {_.orderBy(examObject.formFields, ['id'], ['asc']).map(
                        (_formElement, formElementIndex) => (
                          <Fragment
                            key={`Form_Element_${_formElement.fieldName}`}
                          >
                            {(_formElement.fieldType === 'Single Line Text' ||
                              _formElement.fieldType === 'Link') && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>

                                  <CustomTextInput
                                    value={formFields[_formElement.fieldName]}
                                    onChangeValue={(_value) => {
                                      setFormFields((pre) => {
                                        pre[_formElement.fieldName] = _value;
                                        return Object.assign({}, pre);
                                      });
                                    }}
                                    inputType={'text'}
                                    helperText={
                                      formHelperText[_formElement.fieldName]
                                    }
                                  />
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Email' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  <div className={cssClasses.ButtonWrap}>
                                    <CustomTextInput
                                      value={formFields[_formElement.fieldName]}
                                      onChangeValue={(_value) => {
                                        setFormFields((pre) => {
                                          pre[_formElement.fieldName] = _value;
                                          return Object.assign({}, pre);
                                        });
                                      }}
                                      inputType={'email'}
                                      helperText={
                                        formHelperText[_formElement.fieldName]
                                      }
                                    />
                                  </div>
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Number' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div className={cssClasses.inputWrapper} key={`Form_Element_${ _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  <div className={cssClasses.ButtonWrap}>
                                    <CustomTextInput
                                      value={formFields[_formElement.fieldName]}
                                      onChangeValue={(_value) => {
                                        const re = new RegExp(/^\d+$/);
                                        if (re.test(_value)) {
                                          setFormFields((pre) => {
                                            pre[_formElement.fieldName] =
                                              _value;
                                            return Object.assign({}, pre);
                                          });
                                        }
                                      }}
                                      inputType={'number'}
                                      helperText={
                                        formHelperText[_formElement.fieldName]
                                      }
                                    />
                                  </div>
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Phone No.' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  <div className={cssClasses.ButtonWrap}>
                                    <CustomTextInput
                                      value={formFields[_formElement.fieldName]}
                                      onChangeValue={(_value) => {
                                        const re = new RegExp(/^\d+$/);
                                        if (re.test(_value)) {
                                          setFormFields((pre) => {
                                            pre[_formElement.fieldName] =
                                              _value;
                                            return Object.assign({}, pre);
                                          });
                                        }
                                      }}
                                      inputType={'tel'}
                                      maxValue={10}
                                      helperText={
                                        formHelperText[_formElement.fieldName]
                                      }
                                    />
                                  </div>
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Multiple choice' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>

                                  <CustomRadio
                                    value={formFields[_formElement.fieldName]}
                                    optionList={_formElement.options}
                                    onChangeValue={(_value) => {
                                      // console.log("_value", _value);
                                      setFormFields((pre) => {
                                        pre[_formElement.fieldName] = _value;
                                        return Object.assign({}, pre);
                                      });
                                    }}
                                    helperText={
                                      formHelperText[_formElement.fieldName]
                                    }
                                  />
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Checkboxes' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  <CustomCheckBox
                                    value={formFields[_formElement.fieldName]}
                                    optionList={_formElement.options}
                                    onChangeValue={(_value) => {
                                      setFormFields((pre) => {
                                        if (
                                          pre[_formElement.fieldName].findIndex(
                                            (f) => f === _value
                                          ) === -1
                                        ) {
                                          pre[_formElement.fieldName].push(
                                            _value
                                          );
                                        } else {
                                          pre[_formElement.fieldName].splice(
                                            pre[
                                              _formElement.fieldName
                                            ].findIndex((f) => f === _value),
                                            1
                                          );
                                        }
                                        return Object.assign({}, pre);
                                      });
                                    }}
                                    helperText={
                                      formHelperText[_formElement.fieldName]
                                    }
                                  />
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Date' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: ' 2rem 1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  <div className={cssClasses.ButtonWrap}>
                                    <CustomDate
                                      value={formFields[_formElement.fieldName]}
                                      onChangeValue={(_value) => {
                                        // console.log({ _value });
                                        setFormFields((pre) => {
                                          if (_value !== 'Invalid Date') {
                                            pre[_formElement.fieldName] =
                                              _value;
                                          }
                                          return Object.assign({}, pre);
                                        });
                                      }}
                                      helperText={
                                        formHelperText[_formElement.fieldName]
                                      }
                                    />
                                  </div>
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Dropdown' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>

                                  <Dropdown
                                    selectedValue={
                                      formFields[_formElement.fieldName]
                                    }
                                    list={_formElement.options}
                                    onChangeSelect={(_value) => {
                                      setFormFields((pre) => {
                                        pre[_formElement.fieldName] = _value;
                                        return Object.assign({}, pre);
                                      });
                                    }}
                                    helperText={
                                      formHelperText[_formElement.fieldName]
                                    }
                                  />
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Upload Image' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  {formFields[_formElement.fieldName] === '' ? (
                                    <div
                                      style={{
                                        borderWidth: 1,
                                        borderColor:
                                          formHelperText[
                                            _formElement.fieldName
                                          ] === ''
                                            ? '#D0D5DD'
                                            : 'red',
                                        border: '1px solid #D0D5DD',
                                        borderRadius: 2,
                                        padding: 25,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        margin: '1rem 0 ',
                                      }}
                                    >
                                      <div>
                                        <CloudUploadOutlinedIcon fontSize='large' />
                                      </div>
                                      <div>
                                        <p
                                          style={{
                                            color: '#6941C6',
                                            fontSize: 12,
                                            fontWeight: '500',
                                            fontStyle: 'normal',
                                            textAlign: 'center',
                                            marginLeft: 10,
                                            cursor: 'pointer',
                                          }}
                                          onClick={() => {
                                            document
                                              .getElementById(
                                                `${_formElement.fieldName}_file`
                                              )
                                              .click();
                                          }}
                                        >
                                          Click to Upload
                                        </p>
                                      </div>
                                      <p className={cssClasses.subTitle}>
                                        SVG, PNG, JPG (max. 1024x1024px)
                                      </p>
                                    </div>
                                  ) : (
                                    <div className={cssClasses.row}>
                                      <div
                                        className={cssClasses.column}
                                        id={'caption'}
                                      >
                                        <span className={cssClasses.text}>
                                          <Button
                                            style={{
                                              color: '#ffffff',
                                              backgroundColor: '#7F56D9',
                                            }}
                                            btnName={'Change Image'}
                                            clicked={() => {
                                              document
                                                .getElementById(
                                                  `${_formElement.fieldName}_file`
                                                )
                                                .click();
                                            }}
                                          />
                                        </span>
                                        <img
                                          src={
                                            _formElement.fieldName === 'Photo'
                                              ? 'https://exam-management.s3.ap-south-1.amazonaws.com/' +
                                                formFields[
                                                  _formElement.fieldName
                                                ]
                                              : formFields[
                                                  _formElement.fieldName
                                                ]
                                          }
                                          alt={''}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <input
                                    hidden
                                    accept='image/*'
                                    type='file'
                                    id={`${_formElement.fieldName}_file`}
                                    onChange={(e) => {
                                      let _file = e.target.files[0];
                                      if (_file.size > 1000000) {
                                        errorToast(
                                          'Please Upload a File less than 1 mb'
                                        );
                                      } else {
                                        selectFile(
                                          e.target.files[0],
                                          _formElement.fieldType,
                                          _formElement.fieldName
                                        );
                                      }
                                    }}
                                  />
                                  <p className={cssClasses.helperText}>
                                    {formHelperText[_formElement.fieldName]}
                                  </p>
                                </div>
                              </Grid>
                            )}

                            {_formElement.fieldType === 'Upload PDF' && (
                              <Grid xs={12} sm={12} md={12} lg={12} item>
                                <div
                                  className={cssClasses.inputWrapper}
                                  key={`Form_Element_${
                                    _formElement.fieldName +
                                    '_' +
                                    formElementIndex
                                  }`}
                                  style={{ margin: '1rem' }}
                                >
                                  <p className={cssClasses.inputLabel}>
                                    {_formElement.fieldName}{' '}
                                    {_formElement.isRequired ? (
                                      <span style={{ color: 'red' }}> * </span>
                                    ) : (
                                      ''
                                    )}{' '}
                                  </p>
                                  {formFields[_formElement.fieldName] === '' ? (
                                    <div
                                      style={{
                                        border: '1px solid #D0D5DD',
                                        borderWidth: 1,
                                        borderColor:
                                          formHelperText[
                                            _formElement.fieldName
                                          ] === ''
                                            ? '#D0D5DD'
                                            : 'red',
                                        borderRadius: 2,
                                        padding: 25,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        margin: '1rem 0 ',
                                      }}
                                    >
                                      <div>
                                        {' '}
                                        <CloudUploadOutlinedIcon fontSize='large' />
                                      </div>
                                      <p
                                        style={{
                                          color: '#6941C6',
                                          fontSize: 12,
                                          fontWeight: '500',
                                          fontStyle: 'normal',
                                          marginLeft: 10,
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                          document
                                            .getElementById(
                                              `${_formElement.fieldName}_file`
                                            )
                                            .click();
                                        }}
                                      >
                                        Click to Upload
                                      </p>
                                      <p className={cssClasses.subTitle}>
                                        PDF(max. 1024x1024px)
                                      </p>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        border: '0.5px solid #D0D5DD',
                                        margin: '1rem',
                                        padding: '1rem',
                                      }}
                                    >
                                      <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        className={cssClasses.ButtonWrapper}
                                      >
                                        <p className={cssClasses.fileNameText}>
                                          {fileName}
                                        </p>
                                        <div style={{ marginLeft: 'auto' }}>
                                          <Button
                                            style={{
                                              color: '#ffffff',
                                              backgroundColor: '#7F56D9',
                                            }}
                                            btnName={'Change PDF'}
                                            clicked={() => {
                                              document
                                                .getElementById(
                                                  `${_formElement.fieldName}_file`
                                                )
                                                .click();
                                            }}
                                          />
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                          <Button
                                            style={{
                                              color: '#ffffff',
                                              backgroundColor: '#7F56D9',
                                            }}
                                            btnName={'Preview'}
                                            clicked={() => {
                                              window.open(
                                                formFields[
                                                  _formElement.fieldName
                                                ]
                                              );
                                            }}
                                          />
                                        </div>
                                      </Grid>
                                    </div>
                                  )}
                                  <input
                                    hidden
                                    accept='application/pdf'
                                    type='file'
                                    id={`${_formElement.fieldName}_file`}
                                    onChange={(e) => {
                                      let _file = e.target.files[0];
                                      if (_file.size > 1000000) {
                                        errorToast(
                                          'Please Upload a File less than 1 mb'
                                        );
                                      } else {
                                        selectFile(
                                          e.target.files[0],
                                          _formElement.fieldType,
                                          _formElement.fieldName
                                        );
                                      }
                                    }}
                                  />
                                  <p className={cssClasses.helperText}>
                                    {formHelperText[_formElement.fieldName]}
                                  </p>
                                </div>
                              </Grid>
                            )}
                          </Fragment>
                        )
                      )}
                    </Grid>
                  </div>
                )}

              {examObject &&
                formFields &&
                formHelperText &&
                progressBarStatus === 1 && (
                  <div
                    style={{
                      marginTop: 10,
                      flex: 1,
                      margin: ' 2rem 11rem',
                      backgroundColor: '#FFFFFF',
                      paddingBottom: '2rem',
                    }}
                  >
                    {/* For Offline  */}
                    {(examObject.paymentType === 'Offline' ||
                      examObject.paymentType === 'Both') && (
                      <div
                        style={{ marginTop: 10, backgroundColor: '#FFFFFF' }}
                      >
                        <div>
                          <p
                            style={{
                              margin: '2rem 0',
                              textAlign: 'center',
                              fontSize: '3rem',
                            }}
                          >
                            Bank Details
                          </p>
                          <div className={cssClasses.bankDetailsWrapper}>
                            <p>
                              Bank name : {examObject?.bankDetails?.bankName}
                            </p>
                            <p>
                              Bank branch : {examObject?.bankDetails?.branch}
                            </p>
                            <p>
                              Bank account name :{' '}
                              {examObject?.bankDetails?.accName}
                            </p>
                            <p>
                              Bank account number :{' '}
                              {examObject?.bankDetails?.accNo}
                            </p>
                            <p>Bank IFSC : {examObject?.bankDetails?.IFSC}</p>
                            <p>Exam Fees : {examObject?.fee}</p>
                          </div>
                        </div>
                        <p
                          className={cssClasses.inputLabel}
                          style={{ fontSize: '2rem' }}
                        >
                          Please upload transition slip{' '}
                          <span style={{ color: 'red' }}> * </span>{' '}
                        </p>
                        {!paymentSlipOffline && (
                          <div
                            style={{
                              borderWidth: 1,
                              // borderColor: formHelperText[_formElement.fieldName] === "" ? "#528FF0" : "red",
                              border: '1px solid #D0D5DD',
                              borderRadius: 2,
                              padding: 25,
                              flexDirection: 'column',
                              alignItems: 'center',
                              marginTop: 10,
                              display: 'flex',
                              cursor: 'pointer',

                              margin: '1rem 0 ',
                            }}
                          >
                            <CloudUploadOutlinedIcon fontSize='large' />
                            <p
                              style={{
                                color: '#6941C6',
                                fontSize: 12,
                                fontWeight: '500',
                                fontStyle: 'normal',
                                textAlign: 'center',
                                marginLeft: 10,
                              }}
                              onClick={() => {
                                document
                                  .getElementById('Offline_Process_file')
                                  .click();
                              }}
                            >
                              Click to Upload
                            </p>
                            <p className={cssClasses.subTitle}>
                              {' '}
                              PNG, JPG (max. 1024x1024px)
                            </p>
                          </div>
                        )}
                        {paymentSlipOffline && (
                          <>
                            <div
                              style={{
                                borderWidth: 1,
                                // borderColor: formHelperText[_formElement.fieldName] === "" ? "#528FF0" : "red",
                                borderColor: '#528FF0',
                                border: '1px solid #D0D5DD',
                                borderRadius: 2,
                                padding: 15,
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginBottom: 10,
                              }}
                            >
                              <img
                                style={{ width: 100, height: 100 }}
                                alt={''}
                                src={URL.createObjectURL(paymentSlipOffline)}
                              />
                            </div>
                            <Button
                              clicked={() => {
                                document
                                  .getElementById('Offline_Process_file')
                                  .click();
                              }}
                              style={{
                                color: '#ffffff',
                                backgroundColor: '#6941C6',
                              }}
                              btnName={'Replace Slip'}
                            />
                          </>
                        )}
                        <input
                          hidden
                          accept='image/*'
                          type='file'
                          id={`Offline_Process_file`}
                          onChange={(e) => {
                            let _file = e.target.files[0];
                            if (_file.size > 1000000) {
                              errorToast('Please Upload a File less than 1 mb');
                            } else {
                              selectFilePaymentSlip(
                                e.target.files[0],
                                'Offline'
                              );
                            }
                          }}
                        />

                        {examObject.paymentType === 'Both' && (
                          <div style={{ margin: '2rem 0' }}>
                            <Divider style={{ fontSize: '2rem' }}>OR</Divider>
                            <div
                              style={{
                                marginTop: '2rem',
                                width: 'fit-content',
                                margin: 'auto',
                                paddingTop: '4rem',
                              }}
                            >
                              <Button
                                btnName='Online Process'
                                clicked={() => {
                                  processToOnlinePayment();
                                }}
                                style={{
                                  color: '#ffffff',
                                  backgroundColor: '#6941C6',
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
            </div>
          )}
      </Box>

      <Box style={{ marginTop: 10 }}>
        {progressBarStatus === 0 && examObject.paymentType === 'Online' && (
          <div
            style={{
              width: '100%',
              backgroundColor: '#FFFFFF',
              borderTop: '1px solid #D0D5DD',
            }}
          >
            <div className={cssClasses.ButtonWrapper}>
              <div className={cssClasses.ButtonWrap}>
                <Button
                  style={{ color: '#ffffff', backgroundColor: '#7F56D9' }}
                  btnName={'Pay Now'}
                  padding={'1rem 2.75rem'}
                  disable={payNowButton}
                  clicked={() => {
                    processToOnlinePayment();
                  }}
                />
              </div>
              <div className={cssClasses.ButtonWrap}>
                <Button
                  style={{ color: '#ffffff', backgroundColor: '#3C4952' }}
                  btnName={'Save'}
                  disable={studentInfoFromExam?.paymentStatus === 'done'}
                  clicked={apply}
                />
              </div>
            </div>
          </div>
        )}

        {progressBarStatus === 0 &&
          (examObject.paymentType === 'Offline' ||
            examObject.paymentType === 'Both') && (
            <div
              style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #D0D5DD',
              }}
            >
              <div className={cssClasses.ButtonWrapper}>
                <div className={cssClasses.ButtonWrap}>
                  <Button
                    style={{ color: '#ffffff', backgroundColor: '#3C4952' }}
                    btnName={'Save'}
                    disable={studentInfoFromExam?.paymentStatus === 'done'}
                    clicked={apply}
                  />
                </div>
              </div>
            </div>
          )}

        {progressBarStatus === 1 && (
          <>
            {(examObject.paymentType === 'Offline' ||
              examObject.paymentType === 'Both') && (
              <div
                style={{
                  width: '100%',
                  backgroundColor: '#FFFFFF',
                  borderTop: '1px solid #D0D5DD',
                }}
              >
                <div className={cssClasses.ButtonWrapper}>
                  <Button
                    btnName='Save'
                    clicked={savePayment}
                    style={{ color: '#ffffff', backgroundColor: '#3C4952' }}
                    disable={payNowOfflineButton}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}

export default ExamDetails;

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
